import { getEnv } from "@/env";
import { Pathnames, DomainsConfig } from "next-intl/routing";
import {
  LEARN_HUB_CATEGORY_PATHNAME,
  LEARN_HUB_PATHNAME,
} from "@/lib/locale/learnHubPathnames";

const locales = ["en", "es"] as const;
type Locale = (typeof locales)[number];
const defaultLocale = "en";

function isLocale(value: string): value is Locale {
  return (locales as readonly string[]).includes(value);
}

function resolveLocale(value: string): Locale {
  return isLocale(value) ? value : defaultLocale;
}

const localePrefix = "as-needed";
const localeCookie = false;
const localeDetection = false; // cloudflare caches the locale detection-based redirect for everyone - no bueno
const alternateLinks = false;

const domainUrl = new URL(
  getEnv("NEXT_PUBLIC_SITE_URL", "https://www.edx.org"),
);
const domain = domainUrl.hostname;

// Keep learn hub paths identical across locales. CMS Spanish twins live under
// `/es/learn/...` (mirroring the English slug), not `/es/aprende/...`.
const pathnames = {
  "/": "/",
  [LEARN_HUB_PATHNAME]: LEARN_HUB_PATHNAME,
  [LEARN_HUB_CATEGORY_PATHNAME]: LEARN_HUB_CATEGORY_PATHNAME,
} satisfies Pathnames<typeof locales>;

const domains = [
  {
    domain,
    defaultLocale: "en",
    locales: ["en", "es"],
  },
] satisfies DomainsConfig<typeof locales>;

export {
  locales,
  type Locale,
  isLocale,
  resolveLocale,
  defaultLocale,
  localePrefix,
  localeCookie,
  localeDetection,
  pathnames,
  domains,
  alternateLinks,
};
